import HomePage from '../src/pages/HomePage';

export default HomePage;
